import React, { useEffect, useState } from "react";
import "./home.css";
import img from "../props/avatar.jpg";
import Buttons from "../button/button";
import { BsMouse } from "react-icons/bs";

const ExpandableText = ({ children, descriptionLength }) => {
  const fullText = children;
  const [isExpanded, setIsExpanded] = useState(false);

  const toggleText = () => {
    setIsExpanded(!isExpanded);
  };

  return (
    <div className="text">
      {isExpanded ? (
        <>
          {fullText}
          <span onClick={toggleText} className="toggle-button" id="one">
            Show less
          </span>
        </>
      ) : (
        <>
          {`${fullText.slice(0, descriptionLength)}...`}
          <span onClick={toggleText} className="toggle-button" id="two">
            Show more
          </span>
        </>
      )}
    </div>
  );
};

function Home() {
  useEffect(() => {
    const toggle = document.querySelector(".main-img");
    toggle.addEventListener("click", () => {
      toggle.classList.toggle("active");
    });
  }, []);

  return (
    <div id="home" className="container home-container">
      <div className="logo">
        <div className="main-img">
          <span className="circle"></span>
          <span className="circle"></span>
          <span className="circle"></span>
          <span className="circle"></span>
          <span className="circle"></span>
          <span className="circle"></span>
          <span className="circle"></span>
          <span className="circle"></span>
        </div>

        <img src={img} alt="" />
      </div>

      <a href="#footer" className="scroll-down">
        <hr />
        <h5>scroll down</h5>
        <BsMouse className="scroll" />
        <hr />
      </a>

      <h2>
        <span className="about">About Me</span> <br />
        <div className="paragraph">
          Hello, I'm Adas Mahdi Atef, a passionate full stack developer with a
          Bachelor's degree in Mechatronics Engineering.<span id="short-cut"> My educational
          background in Mechatronics Engineering has equipped me with a solid
          foundation in combining mechanical engineering, electronics, and
          computer science to create innovative and automated systems. <br />
          <br />
          <ExpandableText descriptionLength={120}>
            In addition to my expertise in Mechatronics Engineering, I have honed
            my skills in HTML, JavaScript, CSS, and PHP, making me a versatile
            full stack developer. I am dedicated to crafting attractive and
            functional websites and applications that deliver exceptional user
            experiences. With a keen eye for detail, a creative mindset, and a
            problem-solving approach, I can transform ideas into visually
            appealing and engaging digital experiences. I continually stay updated
            with the latest technologies to ensure the highest level of quality
            and innovation in my work.
          </ExpandableText>
          </span> 
        </div>
      </h2>
      <Buttons />
    </div>
  );
}

export default Home;
